import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Home, ShoppingBag, Calculator, Sun, User } from 'lucide-react';
import { useCart, useAuth } from '../App';

const MobileBottomNav = () => {
    const location = useLocation();
    const { cartCount } = useCart();
    const { user } = useAuth();

    const tabs = [
        { path: '/', icon: Home, label: 'Home' },
        { path: '/shop', icon: ShoppingBag, label: 'Shop', badge: cartCount },
        { path: '/calculator', icon: Calculator, label: 'Calc' },
        { path: '/subsidy', icon: Sun, label: 'Subsidy' },
        {
            path: user
                ? user.role === 'vendor' ? '/vendor/dashboard' : '/dashboard'
                : '/login',
            icon: User,
            label: user ? 'Me' : 'Login',
        },
    ];

    // Don't show on vendor/admin dashboard pages
    const hiddenPaths = ['/vendor/', '/admin/'];
    if (hiddenPaths.some(p => location.pathname.startsWith(p))) return null;

    return (
        <nav className="md:hidden mobile-bottom-nav">
            <div className="mobile-bottom-nav-inner">
                {tabs.map((tab) => {
                    const Icon = tab.icon;
                    const isActive = tab.path === '/'
                        ? location.pathname === '/'
                        : location.pathname.startsWith(tab.path);

                    return (
                        <Link
                            key={tab.path}
                            to={tab.path}
                            className={`mobile-nav-item ${isActive ? 'active' : ''}`}
                        >
                            <AnimatePresence>
                                {isActive && (
                                    <motion.div
                                        className="mobile-nav-indicator"
                                        layoutId="bottomNavIndicator"
                                        transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                                    />
                                )}
                            </AnimatePresence>

                            <div className="mobile-nav-icon-wrapper">
                                <motion.div
                                    animate={isActive ? { scale: 1.1 } : { scale: 1 }}
                                    transition={{ type: 'spring', stiffness: 400, damping: 20 }}
                                >
                                    <Icon
                                        className="mobile-nav-icon"
                                        strokeWidth={isActive ? 2.5 : 1.8}
                                    />
                                </motion.div>
                                {tab.badge > 0 && (
                                    <motion.span
                                        initial={{ scale: 0 }}
                                        animate={{ scale: 1 }}
                                        className="mobile-nav-badge"
                                    >
                                        {tab.badge > 9 ? '9+' : tab.badge}
                                    </motion.span>
                                )}
                            </div>

                            <span className="mobile-nav-label">{tab.label}</span>
                        </Link>
                    );
                })}
            </div>
        </nav>
    );
};

export default MobileBottomNav;
